<template>
    <div>
        <b-modal
            id="nationalTrademarkResponsibleFormModal"
            centered
            size="xl"
            no-close-on-backdrop
            ref="nationalTrademarkResponsibleFormModal"
            :title=" $t('nationalTrademarkResponsible.info')"
            :cancel-title=" $t('others.cancel_title')"
            :ok-title=" $t('others.ok_title')"
            cancel-variant="outline-secondary"
            @ok.prevent="addOrUpdate"
            hide-footer
        >
        <b-card no-body class="border mt-1">
            <b-card-header class="p-1">
              <b-card-title class="font-medium-2">
                <feather-icon icon="LockIcon" size="18" />
                <span class="align-middle ml-50">{{  $t('nationalTrademarkResponsible.responsible')  }}</span>
              </b-card-title>
            </b-card-header>
            <!--eslint-disable-->
            <table class="table table-striped table-bordered">
              <tbody>
                <tr v-for="nationalTrademarkResponsibleItem in nationalTrademarkResponsibleList" :key="nationalTrademarkResponsibleItem.id">
                  <td >
                      <b-form-checkbox @change="changeResponsible($event, nationalTrademarkResponsibleItem.id, nationalTrademarkResponsibleItem.mailContactTypeId)" />                                 
                  </td>
                  <td>{{  nationalTrademarkResponsibleItem.name  }}</td>
                  <td>{{ nationalTrademarkResponsibleItem.email  }}</td>
                  <td>
                    <b-form-select v-model="nationalTrademarkResponsibleItem.mailContactTypeId" value-field="id" text-field="name" :options="mailContactTypeList" />
                  </td>
                  <td>{{ nationalTrademarkResponsibleItem.responsibleField  }}</td>
                </tr>
              </tbody>
            </table>
          </b-card>
        </b-modal>
    </div>
</template>
<script>
export default{
  props: {
      getNationalTrademarkResponsibleList: {type: Function},
    },
  data(){
    return {
      id: 0,
      nationalTrademarkResponsibleList:[],
      mailContactTypeList:[],
    }
  },
  methods:{
    changeResponsible(selected, clientResponsibleId, mailContactTypeId) {
      const controller = { name: 'NationalTrademarkResponsible' }
      if (selected == true) {
        const data = { nationalTrademarkId: this.nationalTrademarkId, clientResponsibleId: clientResponsibleId, mailContactTypeId: mailContactTypeId }
        const payload = { data: data, controller: controller }
        this.$store.dispatch('moduleAuth/save', payload).then((response) => {
          if (response.data.resultStatus == true) {
            this.getNationalTrademarkResponsibleList()
            this.$SaveAlert()
          } else {
            this.$WarningAlert(response.data.resultMessage)
          }
        })
      }
    },
    showInfo(nationalTrademarkId, clientId) {
      this.$refs['nationalTrademarkResponsibleFormModal'].show()
      this.nationalTrademarkId= nationalTrademarkId
      const data = {clientId: clientId, nationalTrademarkId:nationalTrademarkId}
      const controller = {name: 'ClientResponsible', actionName:'GetClientResponsibleListForModules'}
      const payload = {data: data, controller: controller}
      this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
        if(response.data.resultStatus == true){    
          this.nationalTrademarkResponsibleList = response.data.clientResponsibleList
          this.mailContactTypeList = response.data.mailContactTypeList
        } else {
          this.$bvModal.hide('nationalTrademarkResponsibleFormModal')
          this.$WarningAlert(response.data.resultMessage)
        }  
      }) 
    }
  }
}
</script>